<div class="tab-content-container mt-3 mb-2">
    @if (showLoader) {
<app-loader></app-loader>
}
    <h4 class="border-bottom">Calibration</h4>
    <div class="so-calibrations-tab">
        @if (showGrid && calibrationConfig) {
        <!-- The old grid had no height: it was as tall as its rows. Same here: toolbar and header, then 30px a row (no paging). -->
        <div class="calibration-tab-grid" [style.height.px]="82 + 30 * (calibrationTypes.length || 2)">
            <inavista-grid #calibrationsGrid class="so-popup-grid"
                [config]="calibrationConfig"
                [actionIcons]="calibrationActionIcons"
                (actionIconClick)="onCalibrationActionIconClick($event)"
                (exportRequested)="onCalibrationExportRequested()" />
        </div>
        }
    </div>
</div>

<!-- Calibration Type: a link while the order is In Progress (isInProgress), plain text otherwise, as before. -->
<ng-template #calibrationTypeCell let-row>
    @if (isInProgress) {
    <a href="javascript:" (click)="onCalibrationLinkClick(row)">{{ row?.calibrationType }}</a>
    } @else {
    {{ row?.calibrationType }}
    }
</ng-template>

@if (showCalibrationPopup) {
<app-ms-dynamic-popup
   
    [tabName]="tab"
    [pageType]="pageType"
    [calibrationType]="calibrationType"
    module="Calibration"
    [orderId]="serviceOrderData?.serviceOrderId || null"
    [data]="calibrationData"
    [serviceOrderData]="serviceOrderData"
    [showComments]="false"
    (onClose)="onCalibrationClose()"
    (onSave)="getPageData($event)"
></app-ms-dynamic-popup>
}

@if (showCertificatePopup) {
<app-pdf-viwer
    [title]="'Calibration Certificate'"
    [serviceOrderId]="serviceOrderData.serviceOrderId"
    [serviceOrderIdLN]="serviceOrderData.serviceOrderIdLN"
    [certificateUrl]="certificateUrl"
    [isCalibrationCertificate]="true"
    [isAlreadySigned]="isAlreadySigned"
    [allowSignature]="true"
    (onClose)="onCertificateViewerClose($event)"
></app-pdf-viwer>
}
